import React, { useState } from 'react';
import Dropdown, { MenuItem } from '@ids-ts/dropdown';
import Radio, { RadioGroup } from '@ids/radio';
import Button from '@ids/button';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalContent } from '@ids/modal-dialog';
import InlineMessage from '@ids-beta/inline-message';
import { ReduxEvent, StateTax, taxFormUnavailableMessage } from '../../../assets/pagedata/constant';
import { addToCartPut } from '../../services/checkoutDataService';
import Loader from '../Common/Loader';
import {
  sortByQuantityAsc,
  sortByPriceAsc,
  getCurrentFisicalYear,
  isTaxFormUnavailable,
  taxFormsNextAvlDate,
  isProductOutOfStock,
  convertToSnakeCase,
} from '../Util/CommonUtils';

export const TaxAddToCartXsellPricing = (props) => {
  const pricing = props.skuList && props.skuList.length && props.skuList[0];
  const { loading, error, outOfStockItems = [] } = props;
  const [selectedState, setSelectedState] = useState(null);
  const [cityIncomeTax, setCityIncomeTax] = useState(1);
  const [selectedQuantity, setSelectedQuantity] = useState(null);
  const [showLoader, setShowLoader] = useState(false);
  const [cartSuccess, setCartSuccess] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [openModal, setOpenModel] = useState(false);
  const [stateError, setStateError] = useState(null);
  const [outOfStockSkus, setOutOfStockSkus] = useState(null);
  const [outOfStockSingleSku, setOutOfStockSingleSku] = useState(null);
  const mainReducer = useSelector((state) => state.mainReducer);

  const dispatch = useDispatch();


  const displayCityIncomeTax = (state) => {
    if (props.pfid === 'TAX-01') {
      return state && StateTax.find((x) => x.StateCode === state).Ask_w2_question_yn;
    }
    return state && StateTax.find((x) => x.StateCode === state).Ask_1099_question_yn;
  };

  const getPlaceHolder = (msg) => {
    return loading ? 'Loading....' : error ? 'Error' : msg || 'Select Value';
  };

  const showPrices = () => {
    return !!selectedState;
  };

  const getPrices = (state, cityTax) => {
    let prices = [];
    const stTax = StateTax.find((x) => x.StateCode === state);
    if (displayCityIncomeTax(state)) {
      switch (cityTax) {
        case 2:
        case 3:
          prices =
            pricing &&
            pricing.filter(
              (x) =>
                x.Part.indexOf(
                  `${
                    props.pfid === 'TAX-01'
                      ? stTax.PartsFileCityIncomeTax_W2_Yes.toString()
                      : stTax.PartsFileFedCityIncomeTax_1099_Yes.toString()
                  }`,
                ) === 0,
            );
          break;

        case 1:
        default:
          prices =
            pricing &&
            pricing.filter(
              (x) =>
                x.Part.indexOf(
                  `${
                    props.pfid === 'TAX-01'
                      ? stTax.PartsFileCityIncomeTax_W2_No.toString()
                      : stTax.PartsFileFedCityIncomeTax_1099_No.toString()
                  }`,
                ) === 0,
            );
          break;
      }
    } else {
      prices =
        pricing &&
        pricing.filter(
          (x) =>
            x.Part.indexOf(
              `${
                props.pfid === 'TAX-01'
                  ? stTax.PartsFileCityIncomeTax_W2_Yes.toString()
                  : stTax.PartsFileFedCityIncomeTax_1099_Yes.toString()
              }`,
            ) === 0,
        );
    }
    return prices.sort(sortByQuantityAsc);
  };

  const handleOutOfStock = (priceList) => {
    if (priceList && priceList.length > 0) {
      const outOfStockList = priceList.filter((eachsku) => eachsku.OutOfStock);
      if (priceList.length === outOfStockList.length) {
        const outOfStockStatus = isProductOutOfStock(
          {
            pfid: null,
            sku: `${priceList[0].Sku}`,
          },
          outOfStockItems,
        );
        setOutOfStockSkus(outOfStockStatus);
      } else {
        setOutOfStockSkus(null);
      }
    }
  };

  const handleSingleSkuOutOfStock = (sku) => {
    if ( sku && sku.length > 0) {
      const outOfStockStatusSku = isProductOutOfStock(
        {
          pfid: null,
          sku,
        },
        outOfStockItems,
      );
      setOutOfStockSingleSku(outOfStockStatusSku);
    }
  };

  const handleStateChange = (e) => {
    setSelectedState(e.target.value);
    setStateError(null);
    const filterPrices = getPrices(e.target.value, cityIncomeTax);
    handleOutOfStock(filterPrices);
    if (filterPrices.length > 0) {
      const defaultSku = filterPrices.find((x) => x.Quantity === '10').Sku;
      handleSingleSkuOutOfStock(defaultSku);
      setSelectedQuantity(defaultSku);
    }
  };

  const onRadioButtonChange = (e) => {
    setCityIncomeTax(e.target.value);
    const filterPrices = getPrices(selectedState, e.target.value);
    handleOutOfStock(filterPrices);
    if (filterPrices.length > 0) {
      const defaultSku = filterPrices.find((x) => x.Quantity === '10').Sku;
      handleSingleSkuOutOfStock(defaultSku);
      setSelectedQuantity(defaultSku);
    }
  };

  const addToCartSuccess = (pageInfo) => {
    props.logToIMWebLogger('info', `Xsell -> TaxAddToCartXsellPricing: onAddToCartClicked success`);
    dispatch({
      type: ReduxEvent.PAGE_DATA,
      data: {
        pageData: {
          cartCount: pageInfo.CartCount,
          login: pageInfo.login,
          promotionMessage: pageInfo.PromotionMessage,
        },
      },
    });
    const linkData = {
      linkName: 'cartadd',
      aryProducts: [[props.pfid]],
      eventList: 'cartadd',
    };
    props.logToAnalytics({ linkData }, 'link');
    if (props.cartXsellCallBack) {
      props.cartXsellCallBack();
    } else {
      setCartSuccess(true);
    }
    setShowLoader(false);
  };

  const addToCartFailed = (err) => {
    props.logToIMWebLogger(
      'error',
      `Xsell -> TaxAddToCartXsellPricing: onAddToCartClicked failed. Reason: ${err}`,
    );

    props.displayToast('Some error occured. Please try again.');
    setShowLoader(false);
    setCartSuccess(false);
  };

  const onAddToCartClicked = () => {
    if (!selectedState) {
      setStateError('Please select the State');
      return;
    }
    if (!selectedQuantity) {
      return;
    }

    setShowLoader(true);

    if (mainReducer.pageData.cartCount >= 30) {
      props.cartLimitExceed();
      setShowLoader(false);
      return;
    }
    props.logToIMWebLogger('info', `Xsell -> TaxAddToCartXsellPricing: onAddToCartClicked called`);

    const params = {
      IsCustomizable: '0',
      PfId: props.pfid,
      SKU: selectedQuantity,
    };

    addToCartPut(params, addToCartSuccess, addToCartFailed);
  };

  const formatPrice = (val) => {
    const price = val.split('.', 2);
    return (
      <span>
        {price[0]} <sup className="xsell-sup-price">{price[1]}</sup>
      </span>
    );
  };

  const getStartingPrice = () => {
    const sortedSkuList =
      props.skuList && props.skuList.length && props.skuList[0].sort(sortByPriceAsc);
    if (sortedSkuList && sortedSkuList.length && sortedSkuList[0]) {
      if (sortedSkuList[0].DiscPrice && sortedSkuList[0].DiscPrice.length) {
        return formatPrice(sortedSkuList[0].DiscPrice);
      }
      return formatPrice(sortedSkuList[0].ListPrice);
    }
  };

  const handleOpenTaxModal = () => {
    const w2Content = (
      <div className="w2-wrapper">
        <div className="tax-xsell-modal-header">Everything you need to file W-2 forms</div>
        <div>W-2 kits include:</div>
        <ul>
          <li>W-2 forms (two per sheet)</li>
          <li>Four free W-3 forms</li>
          <li>Envelopes</li>
        </ul>
        <div>
          File W-2 forms to report employee wages and salary. A W-3 form is sent to the Social
          Security Administration and summarizes your W-2s and provide proof of quarterly tax
          payments. These forms are usually filed together.
        </div>
      </div>
    );

    const miscContent = (
      <div className="1099-misc-wrapper">
        <div className="tax-xsell-modal-header">Pre-Printed 1099-MISC Kits</div>
        <div>
          <p>
            Use federal 1099-MISC tax forms to report payments of $600 or more for rents, royalties,
            medical and health care payments, and gross proceeds paid to attorneys.
          </p>
          <br />
          <p>
            These new “continuous use” forms no longer include the tax year. QuickBooks will print
            the year on the forms for you
          </p>
        </div>
        <div>1099 kits include:</div>
        <ul>
          <li>{getCurrentFisicalYear()} 1099-MISC forms (two forms per page)</li>
          <li>Four free 1096 forms</li>
          <li>Compatible double-window envelopes</li>
        </ul>
      </div>
    );

    const necContent = (
      <div className="1099-nec-wrapper">
        <div className="tax-xsell-modal-header">Pre-Printed 1099-NEC Kits</div>
        <div>
          Use federal 1099-NEC tax forms to report payments of $600 or more to non-employees
          (contractors). 1096 forms itemize your 1099s on one form and must be filed with your 1099s
        </div>
        <div>1099 kits include:</div>
        <ul>
          <li>{getCurrentFisicalYear()} 1099-NEC forms (two forms per page)</li>
          <li>Four free 1096 forms</li>
          <li>Compatible double-window envelopes</li>
        </ul>
      </div>
    );

    switch (props.pfid) {
      case 'TAX-01':
        setModalContent(w2Content);
        setOpenModel(true);
        break;
      case 'TAX-02':
        setModalContent(miscContent);
        setOpenModel(true);
        break;
      case 'TAX-72':
        setModalContent(necContent);
        setOpenModel(true);
        break;
      default:
        break;
    }
  };

  const handleModalClose = () => {
    setOpenModel(false);
  };

  const handleQuantityChange = (e) => {
    setSelectedQuantity(e.target.value);
    handleSingleSkuOutOfStock(e.target.value);
  };

  return (
    <div className="xsell-tax-container">
      <Loader show={showLoader} size={80} loadingText="Please wait..." />
      <div className="xsell-state-container">
        <div className="xsell-label">State</div>
        <Dropdown
          role="option"
          theme="quickbooks"
          placeholder="Select a State"
          onChange={handleStateChange}
          value={selectedState}
          aria-label="XsellDropdown"
          className="xsell-dropDown dropdown-background-color-white"
          errorText={stateError || null}
          disabled={cartSuccess}
        >
          {StateTax.map((s, key) => {
            return <MenuItem key={`${key}`} value={`${s.StateCode}`}>{`${s.StateCode}`}</MenuItem>;
          })}
        </Dropdown>
      </div>
      {displayCityIncomeTax(selectedState) && (
        <div className="xsell-tax-radio">
          <RadioGroup
            theme="quickbooks"
            name="test"
            value={cityIncomeTax}
            label={
              props.pfid === 'TAX-02'
                ? 'Was State tax withheld on 1099-MISC?'
                : 'Are you required to file City Income Tax?'
            }
            onChange={onRadioButtonChange}
            disabled={cartSuccess}
          >
            <Radio value={1}>No</Radio>
            <Radio value={2}>Yes</Radio>
            <Radio value={3}>I don&#39;t know. Please select for me.</Radio>
          </RadioGroup>
        </div>
      )}
      {outOfStockSkus?.displayOutOfStock && (
        <div className="product-unavailable-msg margin-bottom-20">
          {outOfStockSkus.outOfStockMessage}
        </div>
      )}
      {!outOfStockSkus?.displayOutOfStock && (
        <>
          <div className="xsell-quantity-container">
            <div className="xsell-label">Quantity</div>
            <Dropdown
              role="option"
              theme="quickbooks"
              placeholder={getPlaceHolder(
                !selectedState ? 'Select a state for pricing' : 'Select price',
              )}
              onChange={(e) => handleQuantityChange(e)}
              value={selectedQuantity}
              aria-label="XsellDropdown"
              errorText={error ? 'Unable to fetch the value.' : null}
              className="xsell-dropDown dropdown-background-color-white"
              disabled={cartSuccess}
            >
              {showPrices() ? (
                getPrices(selectedState, cityIncomeTax) !== 0 &&
                getPrices(selectedState, cityIncomeTax).map((q, key) => {
                  return (
                    <MenuItem key={`${key}`} value={`${q.Sku}`}>{`${q.Quantity} for ${
                      q.DiscPrice ? q.DiscPrice : q.ListPrice
                    }`}</MenuItem>
                  );
                })
              ) : (
                <MenuItem disabled value="0">
                  {!selectedState ? 'Select a state for pricing' : 'Select price'}
                </MenuItem>
              )}
            </Dropdown>
          </div>
          <div className="xsell-price-text margin-top-20">
            Starting at <span className="xsell-price">{getStartingPrice()}</span>
          </div>
          <div className="xsell-price-sub-text">
            <i>Price is based on state</i>
          </div>
          {isTaxFormUnavailable() ? (
            <span className="tax-form-unavailable-msg">{`${getCurrentFisicalYear()} ${taxFormUnavailableMessage} ${taxFormsNextAvlDate()}`}</span>
          ) : outOfStockSingleSku?.displayOutOfStock ? (
            <div className="product-unavailable-msg margin-bottom-20">
              {outOfStockSingleSku.outOfStockMessage}
            </div>
          ) : (
            <Button
              theme="quickbooks"
              buttonType="secondary"
              className="xsell-button"
              disabled={cartSuccess}
              styleOverrideReason="none"
              onClick={onAddToCartClicked}
              data-ui-object="button"
              data-refer-ui-access-point={`add_to_cart_xsell| ${convertToSnakeCase(
                props.product.Name,
              )}`}
            >
              Add to cart
            </Button>
          )}
        </>
      )}

      <InlineMessage
        isStatic
        open={cartSuccess}
        className="added-msg"
        content={<div>Added to Cart</div>}
      />

      {!cartSuccess && (
        <div className="row">
          <Button
            theme="quickbooks"
            buttonType="tertiary"
            onClick={handleOpenTaxModal}
            className="xsell-tax-learn-more"
          >
            Learn More
          </Button>
        </div>
      )}

      <Modal
        dismissible
        onClose={() => {
          handleModalClose();
        }}
        className="tax-xsell-modal"
        open={openModal}
        styleOverrideReason="none"
      >
        <ModalContent alignment="left" className="tax-xsell-modal-content">
          {modalContent}
        </ModalContent>
      </Modal>
    </div>
  );
};
